"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingStorage = void 0;
var _ = require("lodash");
var TRACKING_KEY = 'pgx_tracking';
var TrackingStorage = /** @class */ (function () {
    function TrackingStorage() {
        var _this = this;
        this.get = function () {
            try {
                var raw_data = localStorage.getItem(TRACKING_KEY);
                if (!_.isNil(raw_data)) {
                    return JSON.parse(raw_data);
                }
            }
            catch (e) {
                console.warn(e);
            }
            return {};
        };
        this.getField = function (name) {
            return _this.get()[name];
        };
        this.getFieldOrDefault = function (name, default_value) {
            var _a;
            if (name) {
                return (_a = _this.get()[name]) !== null && _a !== void 0 ? _a : default_value;
            }
            return default_value;
        };
        this.setField = function (name, value) {
            if (name) {
                var data = _this.get();
                data[name] = value;
                localStorage.setItem(TRACKING_KEY, JSON.stringify(data));
            }
        };
    }
    TrackingStorage.INSTANCE = new TrackingStorage();
    return TrackingStorage;
}());
exports.TrackingStorage = TrackingStorage;
